import { __decorate, __metadata } from "tslib";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import ClientDetailsMixin from "../ClientDetailsMixin";
import ClientModule from "@/store/modules/client.module";
import EditClientComponent from "./EditClientComponent.vue";
/**
 * Client Details — Profile tab. Read-only profile view, swapped for the inline
 * EditClientComponent while the machine is in editPrimaryInfo.updateClient.
 */
let ClientProfileTabComponent = /** @class */ (() => {
    let ClientProfileTabComponent = class ClientProfileTabComponent extends Mixins(ClientDetailsMixin) {
        constructor() {
            super(...arguments);
            this.descriptionOverflows = false;
            this.onWindowResize = () => this.measureDescription();
        }
        editClient() {
            ClientModule.GetEligibleClientManagers();
            ClientModule.ClearMediaFileData();
            // EditClientComponent edits its own copy of the client (dates included), so Cancel changes nothing here
            this.machineService.send({ type: "UPDATE_CLIENT" });
        }
        phoneLink(value) {
            const dial = (value || "").trim().replace(/[^\d+]/g, "");
            return dial ? `tel:${dial}` : "";
        }
        socialDisplay(value) {
            return (value || "").trim().replace(/^https?:\/\//i, "").replace(/\/$/, "");
        }
        // The edit form stays mounted while the update is in flight (with a loader),
        // so a failed save returns to the form with the typed values kept.
        get isEditingClient() {
            return this.state.matches("loadedClientContactsInfo.editPrimaryInfo.updateClient") || this.isSavingClient;
        }
        get isSavingClient() {
            return this.state.matches("loadedClientContactsInfo.editPrimaryInfo.updatingClient");
        }
        get profileSocials() {
            return [
                { key: "website", label: "Website", icon: "bx-globe", value: (this.client.webSite || "").trim() },
                { key: "linkedin", label: "LinkedIn", icon: "bxl-linkedin", value: (this.client.linkedIn || "").trim() },
                { key: "twitter", label: "X (Twitter)", icon: "bxl-twitter", value: (this.client.twitter || "").trim() },
            ];
        }
        onClientDescriptionChange() {
            this.$nextTick(() => this.measureDescription());
        }
        onEditingClientChange(editing) {
            if (!editing) {
                this.$nextTick(() => this.measureDescription());
            }
        }
        mounted() {
            this.$nextTick(() => this.measureDescription());
            window.addEventListener("resize", this.onWindowResize);
        }
        beforeDestroy() {
            window.removeEventListener("resize", this.onWindowResize);
        }
        // Line-clamp hides the extra height, so compare the unclamped height to the 3-line box.
        measureDescription() {
            const el = this.$refs.descriptionText;
            if (!el) {
                this.descriptionOverflows = false;
                return;
            }
            const wasClamped = el.classList.contains("profile-about-clamp");
            if (wasClamped) {
                el.classList.remove("profile-about-clamp");
            }
            const fullHeight = el.scrollHeight;
            if (wasClamped) {
                el.classList.add("profile-about-clamp");
            }
            const overflows = fullHeight > el.clientHeight + 1;
            if (overflows !== this.descriptionOverflows) {
                this.descriptionOverflows = overflows;
            }
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], ClientProfileTabComponent.prototype, "client", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], ClientProfileTabComponent.prototype, "state", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], ClientProfileTabComponent.prototype, "machineService", void 0);
    __decorate([
        Watch("client.description"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ClientProfileTabComponent.prototype, "onClientDescriptionChange", null);
    __decorate([
        Watch("isEditingClient"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], ClientProfileTabComponent.prototype, "onEditingClientChange", null);
    ClientProfileTabComponent = __decorate([
        Component({
            name: "ClientProfileTabComponent",
            components: {
                EditClientComponent,
            },
        })
    ], ClientProfileTabComponent);
    return ClientProfileTabComponent;
})();
export default ClientProfileTabComponent;
